import React from "react";
import { Button } from "@fluentui/react-components";
import { AppsRegular } from "@fluentui/react-icons";
export const Menu = () => {
    return React.createElement(Button, { appearance: "transparent", icon: React.createElement(AppsRegular, null) });
};
